export const vintage = [
  {
    number: 'HV100',
    hasModel: false
  },
  {
    number: 'HV101',
    hasModel: false
  }
]